export function average(data) {
  const sum = data.reduce(function(sum, value) {
    return sum * 1 + value * 1;
  }, 0);

  return sum / data.length;
}

export function standardDeviation(values) {
  const avg = average(values);

  const squareDiffs = values.map(function(value) {
    const diff = value * 1 - avg;
    return diff * diff;
  });

  const avgSquareDiff = average(squareDiffs);

  return Math.sqrt(avgSquareDiff);
}

export function flattenArray(array) {
  return array.reduce((acc, val) => acc.concat(val), []);
}
